import React, { useEffect, useState, useCallback } from "react";
import { API } from "../../config/api";
import "./../Styles/Settings.css";
import { useNavigate } from "react-router-dom";
import DateFilter from "./DateFilter";

export default function Settings() {
  const [activeTab, setActiveTab] = useState(1);
  const [designerPage, setDesignerPage] = useState(1);
  const [designPage, setDesignPage] = useState(1);
  const [previewProfile, setPreviewProfile] = useState("");
  const navigate = useNavigate();
  const recordsPerPage = 40;
  const [form, setForm] = useState({
    monthly_design_upload_limit: "",
    commission_ratio: "",
    minimum_design_price: "",
    platform_bid_commission: "",
    server_charge: "",
  });

  const [designers, setDesigners] = useState([]);
  const [uploadedDesigns, setUploadedDesigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [designsLoading, setDesignsLoading] = useState(false);

  // States for viewing individual designer detail cards
  const [selectedDesigner, setSelectedDesigner] = useState(null);

  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [designerFilter, setDesignerFilter] = useState("");
  const [soldFilter, setSoldFilter] = useState("");
  const [previewImage, setPreviewImage] = useState("");
  const [paymentFilter, setPaymentFilter] = useState("all");

  const [designerSearch, setDesignerSearch] = useState("");
  const [salesFilter, setSalesFilter] = useState("");
  const [revenueFilter, setRevenueFilter] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const [subcategoryFilter, setSubcategoryFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  // Close popup/modal with Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key !== "Escape") return;

      // Close design image preview
      if (previewImage) {
        setPreviewImage("");
        return;
      }

      // Close profile image preview
      if (previewProfile) {
        setPreviewProfile("");
        return;
      }

      // Close designer profile popup
      if (selectedDesigner) {
        setSelectedDesigner(null);
        return;
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [previewImage, previewProfile, selectedDesigner]);
  const fetchSubcategories = async () => {
    try {
      const res = await fetch(API.LIST_SUBCATEGORY);

      const data = await res.json();

      if (data.status) {
        setSubcategories(data.data);
      } else {
        setSubcategories([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const [concepts, setConcepts] = useState([]);
  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();

      if (data.status) {
        setConcepts(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchConcepts();
    fetchSubcategories();
  }, []);
  const updateUploadStatus = async (id, status) => {
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("design_upload_status", status);

      const res = await fetch(API.UPDATE_DESIGN_UPLOAD_STATUS, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status) {
        setDesigners((prev) =>
          prev.map((designer) =>
            String(designer.id) === String(id)
              ? { ...designer, design_upload_status: status }
              : designer,
          ),
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const updateUploadDate = async (id, field, value) => {
    try {
      const formData = new FormData();

      formData.append("id", id);

      const designer = designers.find((d) => d.id === id);

      formData.append(
        "upload_start_date",
        field === "upload_start_date"
          ? value
          : designer.upload_start_date || "",
      );

      formData.append(
        "upload_expiry_date",
        field === "upload_expiry_date"
          ? value
          : designer.upload_expiry_date || "",
      );

      const res = await fetch(API.UPDATE_DESIGNER_UPLOAD_DATE, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status) {
        setDesigners((prev) =>
          prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  [field]: value,
                }
              : item,
          ),
        );
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const [summary, setSummary] = useState({
    total_designers: 0,
    total_designs: 0,
    today_uploads: 0,
    total_sales: 0,
    total_revenue: 0,
    platform_commission: 0,
    designer_earnings: 0,
    commission_ratio: 0,
    monthly_limit: 0,
  });

  useEffect(() => {
    setDesignPage(1);
  }, [search, categoryFilter, subcategoryFilter, designerFilter, soldFilter]);

  useEffect(() => {
    setDesignerPage(1);
  }, [designerSearch, salesFilter, revenueFilter, paymentFilter]);

  const fetchStatistics = useCallback(async () => {
    try {
      let url = API.ADMIN_DESIGNER_STATISTICS;

      const params = new URLSearchParams();

      if (fromDate) {
        params.append("from_date", fromDate);
      }

      if (toDate) {
        params.append("to_date", toDate);
      }

      if (params.toString()) {
        url += `&${params.toString()}`;
      }

      const res = await fetch(url);
      const data = await res.json();

      if (data.status) {
        setSummary(data.summary);
        setDesigners(data.designers);
      }
    } catch (err) {
      console.error(err);
    }
  }, [fromDate, toDate]);
  useEffect(() => {
    fetchStatistics();
    fetchUploadedDesigns();
  }, [fetchStatistics, fromDate, toDate]);
  const fetchUploadedDesigns = async () => {
    setDesignsLoading(true);
    try {
      const url =
        API.LIST_DESIGNS_USER ||
        `${API.BASE_URL}/api.php?action=list_designsuser`;

      const res = await fetch(url);
      const data = await res.json();
      if (data.status) {
        setUploadedDesigns(data.data);
      }
    } catch (err) {
      console.error("Error fetching uploaded designs:", err);
    } finally {
      setDesignsLoading(false);
    }
  };

  // Find and open designer details right inside the dashboard list context

  const handleOpenDesignerByPhone = (phone) => {
    if (!phone) return;

    const localMatch = designers.find(
      (d) => String(d.phone).trim() === String(phone).trim(),
    );

    if (localMatch) {
      setSelectedDesigner(localMatch);
    } else {
      setSelectedDesigner({
        phone,
        name: "Unknown Designer",
        email: "-",
        total_designs: "Linked items listed below",
        isPlaceholder: true,
      });
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(API.UPDATE_SETTINGS, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      alert(data.message);
      await fetchStatistics();
    } catch (err) {
      console.error("Error updating settings:", err);
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this design?")) return;

    const formData = new FormData();
    formData.append("id", id);

    try {
      const res = await fetch(API.DELETE_DESIGN_user, {
        method: "POST",
        body: formData,
      });

      const text = await res.text();

      const data = JSON.parse(text);
      alert(data.message);

      if (data.status) {
        fetchUploadedDesigns();
      }
    } catch (error) {
      console.error("Delete error:", error);
    }
  };
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // --- Filter Logic Processing ---
  const filteredDesigns = uploadedDesigns.filter((design) => {
    const designDate = design.created_at ? new Date(design.created_at) : null;

    const matchesDate =
      (!fromDate && !toDate) ||
      (designDate &&
        (!fromDate || designDate >= new Date(fromDate)) &&
        (!toDate || designDate <= new Date(toDate + " 23:59:59")));

    const matchesSearch =
      !search ||
      design.design_code?.toLowerCase().includes(search.toLowerCase()) ||
      design.user_name?.toLowerCase().includes(search.toLowerCase());

    const matchesCategory =
      !categoryFilter || design.category === categoryFilter;
    const matchesDesigner =
      !designerFilter || design.user_name === designerFilter;
    const matchesSubcategory =
      !subcategoryFilter ||
      String(design.subcategory) === String(subcategoryFilter);
    const matchesSold =
      !soldFilter ||
      (soldFilter === "sold" && Number(design.sold_times) > 0) ||
      (soldFilter === "unsold" && Number(design.sold_times) === 0);
    return (
      matchesDate &&
      matchesSearch &&
      matchesCategory &&
      matchesSubcategory &&
      matchesDesigner &&
      matchesSold
    );
  });

  const filteredDesigners = designers.filter((designer) => {
    const designerDate = designer.designer_created_date
      ? new Date(designer.designer_created_date)
      : null;

    const matchesDate =
      (!fromDate && !toDate) ||
      (designerDate &&
        (!fromDate || designerDate >= new Date(fromDate)) &&
        (!toDate || designerDate <= new Date(toDate + " 23:59:59")));

    const sTerm = designerSearch.toLowerCase();

    const matchesSearch =
      !designerSearch ||
      designer.name?.toLowerCase().includes(sTerm) ||
      designer.email?.toLowerCase().includes(sTerm) ||
      designer.phone?.toLowerCase().includes(sTerm);

    const matchesSales =
      !salesFilter ||
      (salesFilter === "sold" && Number(designer.total_sales) > 0) ||
      (salesFilter === "unsold" && Number(designer.total_sales) === 0);

    const matchesRevenue =
      !revenueFilter ||
      (revenueFilter === "earning" && Number(designer.total_revenue) > 0) ||
      (revenueFilter === "zero" && Number(designer.total_revenue) === 0);

    const matchesPayment =
      paymentFilter === "all" ||
      (paymentFilter === "pending" && Number(designer.pending_amount) > 0) ||
      (paymentFilter === "paid" && Number(designer.paid_amount) > 0);

    return (
      matchesDate &&
      matchesSearch &&
      matchesSales &&
      matchesRevenue &&
      matchesPayment
    );
  });

  const getSubcategoryName = (id) => {
    const sub = subcategories.find((item) => item.id === id);
    return sub ? sub.name : "-";
  };
  // --- Pagination Calculations ---

  const designerTotalPages = Math.ceil(
    filteredDesigners.length / recordsPerPage,
  );

  const paginatedDesigners = filteredDesigners.slice(
    (designerPage - 1) * recordsPerPage,
    designerPage * recordsPerPage,
  );

  const designTotalPages = Math.ceil(filteredDesigns.length / recordsPerPage);

  const paginatedDesigns = filteredDesigns.slice(
    (designPage - 1) * recordsPerPage,
    designPage * recordsPerPage,
  );
  // const handleOpenDesigner = (userId) => {
  //   const designer = designers.find((d) => Number(d.id) === Number(userId));

  //   if (designer) {
  //     setSelectedDesigner(designer);
  //   }
  // };
  const fetchSettings = async () => {
    try {
      const res = await fetch(API.GET_SETTINGS);
      const data = await res.json();

      if (data.status) {
        setForm({
          monthly_design_upload_limit:
            data.data.monthly_design_upload_limit || "",
          commission_ratio: data.data.commission_ratio || "",
          minimum_design_price: data.data.minimum_design_price || "",
          platform_bid_commission: data.data.platform_bid_commission || "",
          server_charge: data.data.server_charge || "",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchSettings();
  }, []);
  const handleOpenDesigner = (userId) => {
    const designer = designers.find(
      (d) => String(d.id).trim() === String(userId).trim(),
    );

    if (designer) {
      setSelectedDesigner(designer);
    }
  };
  return (
    <div className="container-fluid  p-2 pe-0 bg-light-subtle settings-dashboard-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3 me-5 pe-2">
        <div>
          <h2 className="fw-bold mb-0 text-dark">Designer Report</h2>
        </div>
        <div>
          <DateFilter
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </div>
      </div>

      {/* Light Color Theme Styled Navigation tabs */}
      <ul className="nav nav-pills nav-justified mb-2 dashboard-tabs ">
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link custom-tab-btn ${activeTab === 1 ? "tab-active" : ""}`}
            onClick={() => setActiveTab(1)}
          >
            <i className="bi bi-bar-chart-text me-2"></i>
            Analytics Overview
          </button>
        </li>

        <li className="nav-item">
          <button
            type="button"
            className={`nav-link custom-tab-btn ${activeTab === 2 ? "tab-active" : ""}`}
            onClick={() => setActiveTab(2)}
          >
            <i className="bi bi-currency-dollar me-2"></i>
            Designers List
          </button>
        </li>

        <li className="nav-item">
          <button
            type="button"
            className={`nav-link custom-tab-btn ${activeTab === 3 ? "tab-active" : ""}`}
            onClick={() => setActiveTab(3)}
          >
            <i className="bi bi-palette me-2"></i>
            Uploaded Designs
          </button>
        </li>
      </ul>
      {/* TAB 1 PANEL: Analytics Summary Grid & Config */}
      {activeTab === 1 && (
        <div className="tab-pane-fade">
          <div className="row mb-4">
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 bg-light shadow-sm h-100">
                <div className="card-body text-center d-flex flex-column justify-content-center">
                  <h6 className="text-muted text-uppercase small font-weight-bold">
                    Total Designers
                  </h6>
                  <h2 className="fw-bold text-dark">
                    {summary.total_designers}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 bg-light shadow-sm h-100">
                <div className="card-body text-center d-flex flex-column justify-content-center">
                  <h6 className="text-muted text-uppercase small font-weight-bold">
                    Total Designs
                  </h6>
                  <h2 className="fw-bold text-dark">{summary.total_designs}</h2>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 bg-warning-subtle shadow-sm h-100">
                <div className="card-body text-center d-flex flex-column justify-content-center">
                  <h6 className="text-warning-emphasis text-uppercase small font-weight-bold">
                    Today's Uploads
                  </h6>
                  <h2 className="fw-bold text-warning-emphasis">
                    {summary.today_uploads}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 bg-info-subtle shadow-sm h-100">
                <div className="card-body text-center d-flex flex-column justify-content-center">
                  <h6 className="text-info-emphasis text-uppercase small font-weight-bold">
                    Total Sales
                  </h6>
                  <h2 className="fw-bold text-info-emphasis">
                    {summary.total_sales}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 bg-light shadow-sm h-100">
                <div className="card-body text-center d-flex flex-column justify-content-center">
                  <h6 className="text-muted text-uppercase small font-weight-bold">
                    Total Revenue
                  </h6>
                  <h2 className="fw-bold text-dark">
                    ₹{Number(summary.total_revenue).toLocaleString()}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 bg-success-subtle shadow-sm h-100">
                <div className="card-body text-center d-flex flex-column justify-content-center">
                  <h6 className="text-success text-uppercase small font-weight-bold">
                    Platform Commission
                  </h6>
                  <h2 className="text-success fw-bold">
                    ₹{Number(summary.platform_commission).toLocaleString()}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 bg-primary-subtle shadow-sm h-100">
                <div className="card-body text-center d-flex flex-column justify-content-center">
                  <h6 className="text-primary text-uppercase small font-weight-bold">
                    Designer Earnings
                  </h6>
                  <h2 className="text-primary fw-bold">
                    ₹{Number(summary.designer_earnings).toLocaleString()}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border shadow-sm h-100 bg-body-tertiary">
                <div className="card-body text-center d-flex flex-column justify-content-center">
                  <h6 className="text-muted text-uppercase small font-weight-bold">
                    Global Split Config
                  </h6>
                  <h2 className="fw-bold text-dark">
                    {summary.commission_ratio}%
                  </h2>
                  <small className="text-secondary bg-white rounded py-1 border d-inline-block mt-1 mx-3 p-1">
                    Upload Limit: {summary.monthly_limit}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div className="card border shadow-sm mb-4 w-100">
            <div className="card-header1 bg-light">
              <h5 className="mb-0 fw-bold text-dark d-flex flex-row  justify-content-center align-items-center">
                <i className="bi bi-gear-fill me-2 text-secondary"></i>Global
                System Rules
              </h5>
            </div>
            <div className="card-body p-0 m-0">
              <form onSubmit={handleSubmit}>
                <div className="row p-0 m-0">
                  <div className="col-md-3 mb-4">
                    <label className="form-label fw-bold text-secondary">
                      Monthly Design Upload Limit
                    </label>
                    <input
                      type="number"
                      min="1"
                      className="form-control form-control-lg bg-body"
                      name="monthly_design_upload_limit"
                      value={form.monthly_design_upload_limit}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-3 mb-4">
                    <label className="form-label fw-bold text-secondary">
                      Commission Percentage (%)
                    </label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      className="form-control form-control-lg bg-body"
                      name="commission_ratio"
                      value={form.commission_ratio}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-3 mb-4">
                    <label className="form-label fw-bold text-secondary">
                      Minimum Design Price (₹)
                    </label>

                    <input
                      type="number"
                      min="1"
                      name="minimum_design_price"
                      className="form-control form-control-lg"
                      value={form.minimum_design_price}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-3 mb-4">
                    <label className="form-label fw-bold text-secondary">
                      Server Charge (₹)
                    </label>

                    <input
                      type="number"
                      min="0"
                      className="form-control form-control-lg"
                      name="server_charge"
                      value={form.server_charge}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <button
                  className="btn btn-success px-5 font-weight-bold shadow-sm"
                  disabled={loading}
                >
                  {loading ? "Saving Records..." : "Commit Global Config"}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* TAB 2 PANEL: Designers Ledger Table View */}
      {activeTab === 2 && (
        <div className="tab-pane-fade rounded bg-white shadow-sm border">
          <div className="p-3 border-bottom">
            <h4 className="mb-0 fw-bold text-dark">
              <i className="bi bi-file-earmark-bar-graph me-2 text-success"></i>
              Designer Account Activity Reports
            </h4>
          </div>
          <div className="row g-2 p-3 bg-light align-items-center m-0 border-bottom">
            <div className="col-md-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Name,Email Or Phone"
                value={designerSearch}
                onChange={(e) => setDesignerSearch(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <select
                className="form-select"
                value={salesFilter}
                onChange={(e) => setSalesFilter(e.target.value)}
              >
                <option value="">All </option>
                <option value="sold">Has Sales</option>
                <option value="unsold">No Purchases</option>
              </select>
            </div>
            <div className="col-md-2">
              <select
                className="form-select"
                value={revenueFilter}
                onChange={(e) => setRevenueFilter(e.target.value)}
              >
                <option value="">All Revenue Scales</option>
                <option value="earning">Total Amount &gt; 0</option>
                <option value="zero">Total Amount = 0</option>
              </select>
            </div>

            <div className="col-md-3 d-flex gap-1 justify-content-end">
              <button
                type="button"
                className={`btn btn-sm px-3 ${paymentFilter === "all" ? "btn-secondary" : "btn-outline-secondary"}`}
                onClick={() => setPaymentFilter("all")}
              >
                All
              </button>
              <button
                type="button"
                className={`btn btn-sm px-3 ${paymentFilter === "pending" ? "btn-danger" : "btn-outline-danger"}`}
                onClick={() => setPaymentFilter("pending")}
              >
                Pending
              </button>
              <button
                type="button"
                className={`btn btn-sm px-3 ${paymentFilter === "paid" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setPaymentFilter("paid")}
              >
                Paid
              </button>
            </div>

            <div className="col-md-1 d-flex align-items-end">
              <button
                type="button"
                className="btn btn-light border w-100"
                onClick={() => {
                  setDesignerSearch("");
                  setSalesFilter("");
                  setRevenueFilter("");
                  setPaymentFilter("all");
                }}
              >
                Reset
              </button>
            </div>
          </div>

          <div className="table-responsive p-2 mb-0">
            <table className="table table-hover align-middle custom-report-table mt-1">
              <thead className="table-light text-secondary">
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Image</th>
                  <th>Designer Details</th>
                  <th>Total Designs</th>
                  <th>Total Sales</th>
                  {/* <th>Gross Amount</th>
                  <th>Commission</th> */}
                  <th>Net Earning</th>

                  <th>Paid</th>
                  <th>Pending</th>
                  <th>Start Date</th>
                  <th>Expiry Date</th>
                  <th>Permission</th>
                </tr>
              </thead>
              <tbody>
                {paginatedDesigners.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center py-4 text-muted">
                      No configuration match detected.
                    </td>
                  </tr>
                ) : (
                  paginatedDesigners.map((designer, index) => (
                    <tr key={designer.id || index}>
                      <td>
                        {filteredDesigners.length -
                          ((designerPage - 1) * recordsPerPage + index)}
                      </td>
                      <td>
                        {designer.designer_created_date
                          ? new Date(
                              designer.designer_created_date,
                            ).toLocaleDateString()
                          : "-"}
                      </td>

                      <td className="text-center">
                        {designer.profile_image ? (
                          <>
                            <img
                              src={`${API.BASE_URL}/uploads/profile/${designer.profile_image}`}
                              alt={designer.name}
                              onClick={() =>
                                setPreviewProfile(
                                  `${API.BASE_URL}/uploads/profile/${designer.profile_image}`,
                                )
                              }
                              onError={(e) => {
                                e.target.style.display = "none";
                                e.target.nextElementSibling.style.display =
                                  "inline-flex";
                              }}
                              style={{
                                width: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                cursor: "zoom-in",
                                border: "1px solid #ddd",
                              }}
                            />

                            <div
                              style={{
                                display: "none",
                                width: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                background: "#f1f3f5",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "1px solid #ddd",
                              }}
                            >
                              <i
                                className="bi bi-person-fill"
                                style={{ fontSize: "22px", color: "#6c757d" }}
                              ></i>
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              width: "45px",
                              height: "45px",
                              borderRadius: "50%",
                              background: "#f1f3f5",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "1px solid #ddd",
                            }}
                          >
                            <i
                              className="bi bi-person-fill"
                              style={{ fontSize: "22px", color: "#6c757d" }}
                            ></i>
                          </div>
                        )}
                      </td>
                      <td
                        style={{
                          textAlign: "start",
                          justifyContent: "start",
                        }}
                      >
                        <button
                          type="button"
                          className="btn btn-link p-0 font-weight-bold text-dark border-0 text-start text-decoration-none fw-bold text-primary-hover"
                          onClick={() =>
                            handleOpenDesignerByPhone(designer.phone)
                          }
                        >
                          {designer.name}
                          <i className="bi bi-info-circle small ms-1 text-muted"></i>
                        </button>
                        <div className="text-muted small">{designer.email}</div>
                        <div className="text-muted small">{designer.phone}</div>
                      </td>

                      <td>
                        <span className="badge bg-light text-dark border text-center">
                          {designer.total_designs}
                        </span>
                      </td>
                      <td>
                        <span className="badge bg-light text-dark border text-center">
                          {designer.total_sales}
                        </span>
                      </td>

                      <td className="text-success fw-bold">
                        ₹{Number(designer.earnings).toLocaleString()}
                      </td>
                      <td className="text-secondary">
                        ₹{Number(designer.paid_amount).toLocaleString()}
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-light border btn-sm text-danger fw-bold"
                          onClick={() =>
                            navigate("/admin/add-payment", {
                              state: {
                                designer_id: designer.id,
                                designer_name: designer.name,
                                pending_amount: designer.pending_amount,
                              },
                            })
                          }
                        >
                          ₹{Number(designer.pending_amount).toLocaleString()}{" "}
                          {/* <i className="bi bi-chevron-right ms-1"></i> */}
                        </button>
                      </td>
                      <td>
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={designer.upload_start_date || ""}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (
                              window.confirm(
                                "Are you sure you want to update the Start Date?",
                              )
                            ) {
                              updateUploadDate(
                                designer.id,
                                "upload_start_date",
                                value,
                              );
                            } else {
                              e.target.value = designer.upload_start_date || "";
                            }
                          }}
                        />
                      </td>

                      <td>
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={designer.upload_expiry_date || ""}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (
                              window.confirm(
                                "Are you sure you want to update the Expiry Date?",
                              )
                            ) {
                              updateUploadDate(
                                designer.id,
                                "upload_expiry_date",
                                value,
                              );
                            } else {
                              e.target.value =
                                designer.upload_expiry_date || "";
                            }
                          }}
                        />
                      </td>
                      <td className="text-center">
                        <label className="designer-toggle">
                          <input
                            type="checkbox"
                            checked={
                              designer.design_upload_status === "Enabled"
                            }
                            onChange={(e) =>
                              updateUploadStatus(
                                designer.id,
                                e.target.checked ? "Enabled" : "Disabled",
                              )
                            }
                          />
                          <span className="designer-slider"></span>
                        </label>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {/* Pagination Controls */}
            {designerTotalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center mt-3 bg-light p-2 rounded gap-1">
                {/* Previous Button */}
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={designerPage === 1}
                  onClick={() => setDesignerPage(designerPage - 1)}
                >
                  Prev
                </button>

                {Array.from({ length: designerTotalPages }, (_, i) => i + 1)
                  .filter((page) => {
                    // If less than 7 pages show all
                    if (designerTotalPages <= 7) {
                      return true;
                    }

                    // Always show first and last page
                    if (page === 1 || page === designerTotalPages) {
                      return true;
                    }

                    // Show current page +/- 1
                    if (page >= designerPage - 1 && page <= designerPage + 1) {
                      return true;
                    }

                    return false;
                  })
                  .map((page, index, array) => {
                    const previousPage = array[index - 1];

                    return (
                      <React.Fragment key={page}>
                        {previousPage && page - previousPage > 1 && (
                          <span className="px-2">...</span>
                        )}

                        <button
                          className={`btn btn-sm ${
                            designerPage === page
                              ? "btn-success"
                              : "btn-outline-secondary"
                          }`}
                          onClick={() => setDesignerPage(page)}
                        >
                          {page}
                        </button>
                      </React.Fragment>
                    );
                  })}

                {/* Next Button */}

                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={designerPage === designerTotalPages}
                  onClick={() => setDesignerPage(designerPage + 1)}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* TAB 3 PANEL: Catalog With Interactive Profile Lookups */}
      {activeTab === 3 && (
        <div className="tab-pane-fade rounded bg-white shadow-sm border">
          <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
            <h5 className="mb-0 fw-bold text-dark">
              <i className="bi bi-images me-2 text-success"></i>
              All Uploaded Designs
            </h5>
            <button
              className="btn btn-sm btn-light border"
              onClick={fetchUploadedDesigns}
              disabled={designsLoading}
            >
              {designsLoading ? "Refreshing Database Records..." : "Refresh"}
            </button>
          </div>

          <div className="row g-2 p-3 bg-light m-0 border-bottom">
            <div className="col-md-3">
              <label className="form-label small fw-bold text-muted">
                Search
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Code / Designer Name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label small fw-bold text-muted">
                Category
              </label>
              <select
                className="form-select"
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
              >
                <option value="">All Types</option>
                {[...new Set(uploadedDesigns.map((d) => d.category))]
                  .filter(Boolean)
                  .map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label small fw-bold text-muted">
                Sub Category
              </label>

              <select
                className="form-select"
                value={subcategoryFilter}
                onChange={(e) => setSubcategoryFilter(e.target.value)}
              >
                <option value="">All Sub Categories</option>

                {subcategories
                  .filter((sub) =>
                    uploadedDesigns.some(
                      (d) => String(d.subcategory) === String(sub.id),
                    ),
                  )
                  .map((sub) => (
                    <option key={sub.id} value={sub.id}>
                      {sub.name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-md-2">
              <label className="form-label small fw-bold text-muted">
                Sales
              </label>
              <select
                className="form-select"
                value={soldFilter}
                onChange={(e) => setSoldFilter(e.target.value)}
              >
                <option value="">All Listing Statuses</option>
                <option value="sold">Has Sales </option>
                <option value="unsold">Zero Sales </option>
              </select>
            </div>
            <div className="col-md-1 d-flex align-items-end">
              <button
                type="button"
                className="btn btn-light border w-100"
                onClick={() => {
                  setSearch("");
                  setCategoryFilter("");
                  setSubcategoryFilter("");
                  setDesignerFilter("");
                  setSoldFilter("");
                }}
              >
                Reset
              </button>
            </div>
          </div>

          <div className="table-responsive p-0 m-0">
            <table className="table align-middle table-hover asset-catalog-table mt-1">
              <thead className="table-light text-secondary">
                <tr>
                  <th className="text-center">#</th>
                  <th className="text-center">Date</th>
                  <th className="text-center">Image </th>
                  <th className="text-center">Design Code </th>
                  <th className="text-center">Detail</th>
                  <th className="text-center">Size</th>

                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {designsLoading ? (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      ></div>
                    </td>
                  </tr>
                ) : paginatedDesigns.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-5 text-muted">
                      No listings located matching parameters.
                    </td>
                  </tr>
                ) : (
                  paginatedDesigns.map((design, index) => {
                    const imageUrl = design.jpeg_file
                      ? `${API.BASE_URL}/uploads/Design_seller/${design.user_id}/${design.jpeg_file}`
                      : null;

                    return (
                      <tr key={design.id}>
                        <td>
                          {filteredDesigns.length -
                            ((designPage - 1) * recordsPerPage + index)}
                        </td>

                        <td>
                          {" "}
                          {design.created_at ? (
                            <>
                              <div>
                                {new Date(design.created_at).toLocaleDateString(
                                  "en-GB",
                                )}
                              </div>

                              <small className="text-muted">
                                {new Date(design.created_at).toLocaleTimeString(
                                  [],
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  },
                                )}
                              </small>
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          {imageUrl ? (
                            <img
                              src={imageUrl}
                              alt={design.design_code}
                              className="rounded border img-thumbnail bg-white"
                              style={{
                                width: "95px",
                                height: "105px",
                                objectFit: "cover",
                                cursor: "zoom-in",
                              }}
                              onClick={() => setPreviewImage(imageUrl)}
                            />
                          ) : (
                            <span className="text-muted small">No Image</span>
                          )}
                        </td>
                        <td
                          style={{
                            textAlign: "start",
                            justifyContent: "start",
                            maxWidth: "150px",
                          }}
                        >
                          <div className="tag">
                            <strong>Code:</strong> {design.design_code}
                          </div>
                          <div className="tag">
                            <strong>Concept:</strong>{" "}
                            {design.concepts_array
                              ?.map((id) => {
                                const concept = concepts.find(
                                  (c) => c.id === id,
                                );
                                return concept ? concept.concept_name : null;
                              })
                              .filter(Boolean)
                              .join(", ")}
                          </div>
                        </td>

                        <td
                          style={{
                            textAlign: "start",
                            justifyContent: "start",
                          }}
                        >
                          <div
                            className="gap-1 "
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <span className="tag">
                              <strong>Category:</strong>{" "}
                              {design.category || "General"}
                            </span>

                            <span className="tag">
                              <strong>Sub: </strong>
                              {getSubcategoryName(design.subcategory)}
                            </span>

                            <span className="tag">
                              <strong>Colors:</strong> {design.color || "-"}
                            </span>

                            <span className="tag">
                              <strong>Stitches: </strong>
                              {design.stitch || 0}
                            </span>
                          </div>
                        </td>
                        <td
                          style={{
                            textAlign: "start",
                            justifyContent: "start",
                          }}
                        >
                          <div
                            className="d-flex flex-wrap gap-1"
                            style={{ flexDirection: "column" }}
                          >
                            <span className="tag">
                              <strong>Area: </strong>
                              {design.area || 0}
                            </span>
                            <span className="tag">
                              <strong>Height: </strong>
                              {design.height || 0}
                            </span>
                            <span className="tag">
                              <strong>Width: </strong>
                              {design.width || 0}
                            </span>
                            <span className="tag">
                              <strong>Price: </strong>
                              {design.price || 0}
                            </span>
                          </div>
                        </td>
                        {/* <td className="text-center">
                        
                        </td>
                        <td></td> */}
                        <td
                          className="text-center"
                          style={{ justifyContent: "center" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              margin: "12px",
                              justifyContent: "center",
                              textAlign: "center",
                            }}
                          >
                            <span
                              className={`ad-icon-btn ${Number(design.sold_times) > 0 ? "bg-success-subtle text-success" : "bg-light text-secondary border"}`}
                              style={{ fontSize: "13px" }}
                            >
                              {design.sold_times || 0}
                            </span>
                            <button
                              className="ad-icon-btn ad-delete ms-2"
                              title="Delete"
                              onClick={() => handleDelete(design.id)}
                            >
                              <i className="bi bi-trash3"></i>
                            </button>
                          </div>
                          <div
                            style={{
                              display: "flex",

                              justifyContent: "center",
                              textAlign: "center",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-link p-0 border-0 fw-bold text-success text-decoration-none"
                              style={{
                                transition: "color 0.2s",
                                justifyContent: "center",
                                textAlign: "center",
                              }}
                              onClick={() => handleOpenDesigner(design.user_id)}
                            >
                              <i className="bi bi-person-badge-fill me-1"></i>
                              {design.user_name || "System Master"}
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>

            {/* Pagination Controls */}
            {designTotalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center mt-3 bg-light p-2 rounded gap-1">
                {/* Previous */}
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={designPage === 1}
                  onClick={() => setDesignPage(designPage - 1)}
                >
                  Prev
                </button>

                {Array.from({ length: designTotalPages }, (_, i) => i + 1)
                  .filter((page) => {
                    if (designTotalPages <= 7) {
                      return true;
                    }

                    if (page === 1 || page === designTotalPages) {
                      return true;
                    }

                    if (page >= designPage - 1 && page <= designPage + 1) {
                      return true;
                    }

                    return false;
                  })
                  .map((page, index, array) => {
                    const previous = array[index - 1];

                    return (
                      <React.Fragment key={page}>
                        {previous && page - previous > 1 && (
                          <span className="px-2">...</span>
                        )}

                        <button
                          className={`btn btn-sm ${
                            designPage === page
                              ? "btn-success"
                              : "btn-outline-secondary"
                          }`}
                          onClick={() => setDesignPage(page)}
                        >
                          {page}
                        </button>
                      </React.Fragment>
                    );
                  })}

                {/* Next */}
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={designPage === designTotalPages}
                  onClick={() => setDesignPage(designPage + 1)}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* DYNAMIC DESIGNER PROFILE SLIDE-OVER DETAIL PREVIEW OVERLAY */}

      {selectedDesigner && (
        <div
          className="ds-profile-overlay"
          onClick={() => setSelectedDesigner(null)}
        >
          <div
            className="ds-profile-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ds-profile-header p-2">
              <button
                className="ds-close-btn"
                onClick={() => setSelectedDesigner(null)}
              >
                <i className="bi bi-x-lg"></i>
              </button>
              {/* 
              <div className="ds-avatar">
                <i className="bi bi-person-fill"></i>
              </div> */}

              <h3 className="ds-name">{selectedDesigner.name}</h3>

              {/* <span className="ds-role">Platform Partner</span> */}
            </div>

            <div className="ds-profile-body">
              <div className="ds-row">
                <span>Email</span>
                <strong>{selectedDesigner.email || "Not Configured"}</strong>
              </div>

              <div className="ds-row">
                <span>Phone</span>
                <strong>{selectedDesigner.phone || "Not Verified"}</strong>
              </div>

              <div className="ds-row">
                <span>Total Designs</span>
                <strong>{selectedDesigner.total_designs ?? 0}</strong>
              </div>

              <div className="ds-row">
                <span>Total Sales</span>
                <strong>{selectedDesigner.total_sales ?? 0}</strong>
              </div>

              {!selectedDesigner.isPlaceholder && (
                <>
                  <div className="ds-row">
                    <span>Gross Amount</span>

                    <strong className="ds-success">
                      ₹
                      {Number(
                        selectedDesigner.total_revenue || 0,
                      ).toLocaleString()}
                    </strong>
                  </div>
                  <div className="ds-row">
                    <span>Commtion split</span>

                    <strong className="ds-danger">
                      - ₹
                      {Number(
                        selectedDesigner.commission || 0,
                      ).toLocaleString()}
                    </strong>
                  </div>
                  <div className="ds-row">
                    <span>Net Earnings</span>

                    <strong className="ds-success">
                      ₹{Number(selectedDesigner.earnings || 0).toLocaleString()}
                    </strong>
                  </div>
                  <div className="ds-row">
                    <span>Paid Amount</span>

                    <strong className="ds-success">
                      ₹
                      {Number(
                        selectedDesigner.paid_amount || 0,
                      ).toLocaleString()}
                    </strong>
                  </div>

                  <div className="ds-row">
                    <span>Pending Amount</span>

                    <strong className="ds-danger">
                      ₹
                      {Number(
                        selectedDesigner.pending_amount || 0,
                      ).toLocaleString()}
                    </strong>
                  </div>
                </>
              )}
            </div>

            <div className="ds-footer">
              <button
                className="ds-close-button"
                onClick={() => setSelectedDesigner(null)}
              >
                Close Profile
              </button>
            </div>
          </div>
        </div>
      )}

      {previewImage && (
        <div className="preview-modal" onClick={() => setPreviewImage("")}>
          <div
            className="preview-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="preview-close"
              onClick={() => setPreviewImage("")}
            >
              &times;
            </button>

            <img src={previewImage} alt="Preview" />
          </div>
        </div>
      )}
      {previewProfile && (
        <div className="preview-modal" onClick={() => setPreviewProfile("")}>
          <div
            className="preview-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="preview-close"
              onClick={() => setPreviewProfile("")}
            >
              &times;
            </button>

            <img
              src={previewProfile}
              alt="Profile"
              style={{
                maxWidth: "500px",
                maxHeight: "500px",
                borderRadius: "10px",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
